import {sendWebsocketMessage} from "../../../../../../App";

export function pauseTradePlan(tradePlanId, pause) {
    const message = {
        messageType: "updateTradePlan",
        tradePlanId: tradePlanId,
        value: {"paused": pause},
        field: "pauseTradePlan",
    };
    sendWebsocketMessage(message);
}